import { createSelector } from 'reselect';
import { getCategoryDataForType } from '@selectors/data-types-selector';

// Get calendar event category items:
export const getCalendarEventTypeItems = key => createSelector([getCategoryDataForType(key)], items => items);
